(function () {
	const gallery = document.querySelector('.pdp-main__gallery-sticky');
	const header =
		document.querySelector('.site-header__wrapper') ||
		document.querySelector('[data-section-type="header"]');
	if (!gallery || !header) return;

	const GAP = 20;
	let ticking = false;

	function update() {
		ticking = false;
		const bottom = Math.max(0, header.getBoundingClientRect().bottom);
		document.documentElement.style.setProperty('--pdp-gallery-top', bottom + GAP + 'px');
	}

	function onScroll() {
		if (ticking) return;
		ticking = true;
		requestAnimationFrame(update);
	}

	window.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('resize', onScroll, { passive: true });
	header.addEventListener('transitionend', update);
	update();
})();
